<template>
<section class="page-section page-section--expanded investment-growth" id="growth-table">
  <h2>{{ $t('kano.investment-growth.title', {
      cryptoName: props.cryptoCurrency.name,
      cryptoCode: props.cryptoCurrency.code,
    }) }}</h2>
  <div class="price-list-table-wrapper">
    <div class="price-list-table-wrapper__scroll">
      <table class="price-list-table">
        <thead class="price-list-table__head">
        <tr>
          <th scope="col">
            {{ $t('kano.investment-growth.table-cell-title.date') }}
          </th>
          <th scope="col">
            {{ $t('kano.investment-growth.table-cell-title.price', {
              cryptoCode: props.cryptoCurrency.code,
              fiatCode: props.fiatCurrency.code,
            }) }}
          </th>
          <th scope="col">
            {{ $t('kano.investment-growth.table-cell-title.profit') }}
          </th>
          <th scope="col">
            {{ $t('kano.investment-growth.table-cell-title.balance') }}
          </th>
        </tr>
        </thead>
        <tbody class="price-list-table__body">
        <tr v-for="item in props.investmentData" :key="item.date">
          <td :title="item.date.toLocaleDateString(i18nInstance.locale, {
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })">
            {{ item.date.toLocaleDateString(i18nInstance.locale, {
              year: 'numeric',
              month: 'short',
            }) }}
          </td>
          <td>
            {{ formatAmount(item.price) }}
          </td>
          <td>
            <span :class="item.profitDiff >= 0 ? 'profit--positive' : 'profit--negative'">
              {{ item.profitDiff >= 0 ? '+' : '' }}{{ formatAmount(item.profitDiff) }}
            </span>
          </td>
          <td>
            {{ formatAmount(item.balance) }}
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="investment-growth__cta">
    <CallToAction :cryptoCurrency="props.cryptoCurrency" />
  </div>
</section>
</template>

<script setup lang="ts">
import { InvestmentGrowthData, ProfitCalculatorCurrency } from "@kano/types/profit-calculator";
import { formatNumberStandard, CurrencyFormat } from "@kano/helpers/numberFormatter";
import { i18n as i18nInstance } from "@kano/i18n";
import CallToAction from "@kano/components/ProfitCalculator/CallToAction.vue";

const props = defineProps<{
  investmentData: Array<InvestmentGrowthData>,
  fiatCurrency: ProfitCalculatorCurrency,
  cryptoCurrency: ProfitCalculatorCurrency,
  startAmount: Number,
}>();

const formatAmount = (amount: number) => {
  return formatNumberStandard(amount, i18nInstance.locale, props.fiatCurrency.code, CurrencyFormat.symbol);
}
</script>

<style scoped lang="scss">
.investment-growth {
  & h2 {
    max-width: 672px;
    text-align: center;
    font-size: 28px;
  }

  & .profit--positive {
    color: var(--color-green);
  }

  & .profit--negative {
    color: var(--color-red);
  }

  &__cta {
    text-align: center;
  }
}

.price-list-table-wrapper__scroll {
  min-width: 470px;
}

.price-list-table {
  & th:first-child,
  & td:first-child {
    text-align: start;
  }
}
</style>